'use strict';

export default {
    name: 'vuelidate-helper',

    computed: {
        $allErrors() {
            return this.$getDeepErrors({ $v: this.v }, '$v', '');
        }
    },

    methods: {
        $getDeepErrors(outerObj, outerKey, prefix) {
            const obj = outerObj[outerKey];

            return Object.keys(obj).reduce((acc, key) => {
                if (key.charAt(0) === '$' && key !== '$store' && key !== '$each') return acc;
                if (typeof obj[key] === 'object') {
                    let newPrefix = prefix === '' ? prefix + outerKey : prefix + '.' + outerKey;
                    if (outerKey === '$v') {
                        newPrefix = '';
                    }
                    return acc.concat(this.$getDeepErrors(obj, key, newPrefix));
                }
                if (!obj[key]) {
                    if (prefix.includes('.$each.')) {
                        prefix = prefix.substring(0, prefix.indexOf('.$each.'));
                    }

                    acc.push({
                        key: outerKey,
                        error: key,
                        params: obj.$params[key],
                        prefix: prefix
                    });
                }
                return acc;
            }, []);
        },
        $getShallowErrors(obj) {
            return Object.keys(obj)
                .filter((key) => key.charAt(0) !== '$')
                .filter((key) => !obj[key]);
        }
    },

    created() {
        if (!this.v) {
            throw new Error(
                `vuelidate-helper is meant to be used in a component with vuelidate validations. ${this.name} does not have a $v validation object.`
            );
        }
    }
};
